<!--
  ~ Copyright (C) 2025 - Potentially Ltd
  ~
  ~ Please see distribution for license.
  -->

<section class="feedback-stats-section">
  <div class="feedback-stats-section-top">
    <div class="title-container">
      <ptl-editable-section-title [title]="section?.title" (titleSaved)="saveTitle($event)"> </ptl-editable-section-title>
    </div>
    <ptl-report-top-actions [editIsEnabled]="false" (sectionDelete)="openDialog(section?.uid)">
      <ng-content></ng-content>
    </ptl-report-top-actions>
  </div>

  <div class="feedback-stats-section-inner">
    <mat-card class="feedback-stats-item item-avg-score">
      <div class="feedback-stats-top-box">
        <div class="item-title medium bold">{{ 'translations.diagnostics.feedbackStats.evaluatorFeedbackAverage' | transloco }}</div>
        <mat-slide-toggle
          color="primary"
          class="custom-toggle mat-slide-custom"
          (ngModelChange)="updateStatsVisibility($event, 'AVG_SCORE')"
          [attr.aria-label]="
            averageFeedbackScoreEnable
              ? ' ' + ('translations.global.ariaLabels.enabled' | transloco)
              : ' ' + ('translations.global.ariaLabels.disabled' | transloco)
          "
          [(ngModel)]="averageFeedbackScoreEnable"
        >
        </mat-slide-toggle>
      </div>

      <div class="score-value">4.7</div>
    </mat-card>

    <mat-card class="feedback-stats-item item-avg-ratings">
      <div class="feedback-stats-top-box">
        <div class="item-title medium bold">{{ 'translations.diagnostics.feedbackStats.overallCareerReadiness' | transloco }}</div>
        <mat-slide-toggle
          color="primary"
          class="custom-toggle mat-slide-custom"
          (ngModelChange)="updateStatsVisibility($event, 'AVG_RATING')"
          [attr.aria-label]="
            averageRatingEnable
              ? ' ' + ('translations.global.ariaLabels.enabled' | transloco)
              : ' ' + ('translations.global.ariaLabels.disabled' | transloco)
          "
          [(ngModel)]="averageRatingEnable"
        >
        </mat-slide-toggle>
      </div>

      <div class="rating-value">
        <img src="assets/report/report-rating-bar.png" alt="Average ratings chart" />
      </div>
    </mat-card>

    <mat-card class="feedback-stats-item distance-travelled">
      <div class="feedback-stats-top-box">
        <div class="item-title medium bold">
          <svg class="svg" aria-hidden="true">
            <use ogSvgUnify="assets/sprite/sprite.svg#path"></use>
          </svg>
          {{ 'translations.diagnostics.feedbackStats.distanceTravelled' | transloco }}
        </div>
        <mat-slide-toggle
          color="primary"
          class="custom-toggle mat-slide-custom"
          (ngModelChange)="updateStatsVisibility($event, 'DISTANCE_TRAVELLED')"
          [attr.aria-label]="
            distanceTravelEnable
              ? ' ' + ('translations.global.ariaLabels.enabled' | transloco)
              : ' ' + ('translations.global.ariaLabels.disabled' | transloco)
          "
          [(ngModel)]="distanceTravelEnable"
        >
        </mat-slide-toggle>
      </div>

      <div class="distance-travelled-description small">
        {{ 'translations.diagnostics.feedbackStats.distanceTravelledScoreChanged' | transloco: { date: '23 SEP 2024' } }}
      </div>
      <div class="distance-travelled-value">
        {{ 'translations.diagnostics.feedbackStats.distanceTravelledPoints' | transloco: { number: '+1.8' } }} / 23%
      </div>
    </mat-card>

    <mat-card class="feedback-stats-item item-consensus">
      <div class="feedback-stats-top-box">
        <div class="item-title medium bold">
          <svg class="svg" aria-hidden="true">
            <use ogSvgUnify="assets/sprite/sprite.svg#join"></use>
          </svg>
          {{ 'translations.diagnostics.feedbackStats.consensus' | transloco }}
        </div>
        <mat-slide-toggle
          color="primary"
          class="custom-toggle mat-slide-custom"
          (ngModelChange)="updateStatsVisibility($event, 'CONSENSUS')"
          [attr.aria-label]="
            consensusEnable
              ? ' ' + ('translations.global.ariaLabels.enabled' | transloco)
              : ' ' + ('translations.global.ariaLabels.disabled' | transloco)
          "
          [(ngModel)]="consensusEnable"
        >
        </mat-slide-toggle>
      </div>

      <div class="consensus-row">
        <div class="score medium">93%</div>
        <div class="text small">{{ 'translations.diagnostics.feedbackStats.consensusBetweenEvaluators' | transloco }}</div>
      </div>
      <div class="consensus-row">
        <div class="score medium">23%</div>
        <div class="text small">{{ 'translations.diagnostics.feedbackStats.consensusBetweenUserAndEvaluatorsProviders' | transloco }}</div>
      </div>
    </mat-card>

    <!-- TODO: Hidden until implemented
    <mat-card class="feedback-stats-item item-national-benchmark">
      <div class="feedback-stats-top-box">
        <div class="item-title medium bold">{{ 'translations.diagnostics.feedbackStats.nationalBenchmark' | transloco }}</div>
        <mat-slide-toggle
          color="primary"
          class="custom-toggle mat-slide-custom"
          (ngModelChange)="updateStatsVisibility($event, 'NATIONAL_BENCHMARK')"
          [attr.aria-label]="
            notionalBenchmarkEnable
              ? ' ' + ('translations.global.ariaLabels.enabled' | transloco)
              : ' ' + ('translations.global.ariaLabels.disabled' | transloco)
          "
          [(ngModel)]="notionalBenchmarkEnable"
        >
        </mat-slide-toggle>
      </div>
      <div class="benchmark-row">
        <div class="score-box">
          <svg class="svg" aria-hidden="true">
            <use ogSvgUnify="assets/sprite/sprite.svg#bell-curve-2"></use>
          </svg>
          <div class="score medium">{{ 'translations.diagnostics.feedbackStats.nationalBenchmarkScore' | transloco: { score: 36 } }}</div>
        </div>
        <div class="text small">
          {{ 'translations.diagnostics.feedbackStats.nationalBenchmarkDescription' | transloco: { score: 36 } }}
        </div>
      </div>
    </mat-card>-->

    <mat-card class="feedback-stats-item item-benchmark-college">
      <div class="feedback-stats-top-box">
        <div class="item-title medium bold">
          {{ 'translations.diagnostics.feedbackStats.workspaceBenchmark' | transloco: { orgName: (organizationData$ | async)?.name } }}
        </div>
        <mat-slide-toggle
          color="primary"
          class="custom-toggle mat-slide-custom"
          (ngModelChange)="updateStatsVisibility($event, 'WORKSPACE_BENCHMARK')"
          [attr.aria-label]="
            workspaceBenchmarkEnable
              ? ' ' + ('translations.global.ariaLabels.enabled' | transloco)
              : ' ' + ('translations.global.ariaLabels.disabled' | transloco)
          "
          [(ngModel)]="workspaceBenchmarkEnable"
        >
        </mat-slide-toggle>
      </div>
      <div class="benchmark-row">
        <div class="score-box">
          <svg class="svg" aria-hidden="true">
            <use ogSvgUnify="assets/sprite/sprite.svg#bell-curve-2"></use>
          </svg>
          <div class="score green medium">
            {{ 'translations.diagnostics.feedbackStats.workspaceBenchmarkScore' | transloco: { score: 87 } }}
          </div>
        </div>
        <div class="text small">
          {{ 'translations.diagnostics.feedbackStats.workspaceBenchmarkDescription' | transloco: { score: 87, totalUsers: 1254 } }}
        </div>
      </div>
    </mat-card>
  </div>
</section>
